import { createSelector } from '@ngrx/store';
import { StudentList } from '../../../models/StudentList';
import { AppState } from '../../app-state/app-state';
import { groupsAdapter } from '../reducers';
import { GroupsStates } from './groups.states';

export const getStudentGroupsState = (state: AppState) => state.studentGroups;

export const getStudentGroupsCollection = groupsAdapter.getSelectors(getStudentGroupsState).selectAll;

export const getStudentGroupsEntities = groupsAdapter.getSelectors(getStudentGroupsState).selectEntities;

export const getCurrentStudentGroupId = createSelector(getStudentGroupsState, (state: GroupsStates) => state.currentGroupId);

export const getCurrentStudentGroup = createSelector(getStudentGroupsEntities, getCurrentStudentGroupId, (entities, id) => entities[id]);

export const getLoadingGroups = createSelector(getStudentGroupsState, (state: GroupsStates) => state.loading);

export const getLoadedGroups = createSelector(getStudentGroupsState, (state: GroupsStates) => state.loaded);

export const getGroupsByIds = (ids: number[]) => (state: AppState) => {
	if (state.studentGroups?.entities) {
		const groups: StudentList[] = Object.values(state.studentGroups.entities).filter((group): group is StudentList => group !== undefined);
		return groups.filter((group) => group && ids.includes(group.id));
	}
	return [];
};
